export class Article {
    title: string;
    pathImg: string;
    intro: string;
    content: string;
    date: string;
}
